const INITIAL_STATE = {
  list: [],
  opcoes: { controladores: [], grupos_fisicos: [], equipes: [], usuarios: [], estoque_itens: [] },
  notificacoesControlador: [],
  membrosEquipe: [],
  selectedOS: null,
  pendingNavFromNotification: false,
  finalizarModalOs: null,
  finalizarModalConfirmando: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'OS_FETCHED':
      return { ...state, list: action.payload.data };
    case 'OS_OPCOES_FETCHED':
      return { ...state, opcoes: action.payload };
    case 'OS_NOTIFICACOES_FETCHED':
      return { ...state, notificacoesControlador: action.payload };
    case 'OS_NOTIFICACOES_CLEAR':
      return { ...state, notificacoesControlador: [] };
    case 'OS_MEMBROS_FETCHED':
      return { ...state, membrosEquipe: action.payload };
    case 'OS_MEMBROS_CLEAR':
      return { ...state, membrosEquipe: [] };
    case 'OS_SELECTED':
      return { ...state, selectedOS: action.payload };
    case 'OS_PAGE':
      return { ...state, paginaAtual: action.payload };
    case 'OS_PENDING_NAV':
      return { ...state, pendingNavFromNotification: action.payload };
    case 'OS_FINALIZAR_OPEN':
      return { ...state, finalizarModalOs: action.payload, finalizarModalConfirmando: false };
    case 'OS_FINALIZAR_CLOSE':
      return { ...state, finalizarModalOs: null, finalizarModalConfirmando: false };
    case 'OS_FINALIZAR_CONFIRMANDO':
      return { ...state, finalizarModalConfirmando: action.payload };
    default:
      return state;
  }
};
